import { ErrorsWrapper } from "./ErrorsWrapper";

export class ErrorResponseWrapper extends Error implements ErrorsWrapper<string[]> {

  private readonly response: Response;

  constructor(response: Response) {
    super();
    this.response = response;
  }

  async getErrorMessages(): Promise<string[]> {
    return new Promise<string[]>((resolve) => {
      this.response.json()
        .then((msg: string[]) => {
          (typeof msg === 'string') ? resolve([msg] as any) : resolve(msg);
        })
        .catch(() => resolve([] as any));
    });
  }
}
